<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择项目"
      width="800px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :columns-btn-show="false"
        :filter.sync="filter"
        module="basic"
        url="projects">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="项目名称：">
            <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="projectNo" align="center" label="项目编号" width="120"/>
      <el-table-column prop="projectName" align="left" label="项目名称"/>
      <el-table-column label="操作" align="center" width="80px" prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "ProjectSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          submitStatus: 10,
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>
